import React from 'react';
import Cover from '../components/Cover';
import AboutBox from '../components/AboutBox';
import MenuPreview from '../components/MenuPreview/MenuPreview';
import BookTableSection from '../components/BookTableSection';
import Footer from '../components/Footer';








function Home () {

  return (
    <div style={styles.container}>
      <Cover/>
      <AboutBox/>
      <MenuPreview/>
      <BookTableSection/>
      <Footer/>
    </div>
  );
}

export default Home;

const styles = {
  container: {
    width: '100%',
  }
}